import Swal from "sweetalert2"

export function AlertRepository() {
    return {
        SweetTwoButton
    }
}

function SweetTwoButton(title, text, icon) {
    Swal.fire({
        title: title,
        icon: icon,
        text: text,
        showCloseButton: true,
        confirmButtonColor: '#d7a952'
    })
}

// function SweetOneButton(title, text, icon) {
//     Swal
// }